import usePost, { UsePostOptions } from './use-post'
import { RecommendedBookingApi } from '@beatgig/api/recommended-booking'
import Analytics from '@beatgig/analytics/typez'

export default function useRejectRecommendedBooking(
  options?: UsePostOptions<
    typeof RecommendedBookingApi.rejectRecommendedBooking
  >
) {
  return usePost(
    (
      props: Parameters<
        typeof RecommendedBookingApi.rejectRecommendedBooking
      >[0]
    ) => {
      const { recommendedBookingId, rejectionMessage } = props
      Analytics.track('Reject Recommended Booking', {
        recommendedBookingId,
        rejectionMessage,
      })
      return RecommendedBookingApi.rejectRecommendedBooking(props)
    },
    options
  )
}
